import { render, staticRenderFns } from "./PackingFormFooter.vue?vue&type=template&id=0474b0f4&"
import script from "./PackingFormFooter.vue?vue&type=script&lang=js&"
export * from "./PackingFormFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports